export const FIXED_TIMESTEP_HZ = 60;
export const FIXED_DT = 1 / FIXED_TIMESTEP_HZ;
export const MAX_FRAME_DT = 0.25;

export const WORLD_SIZE = 100;
export const WORLD_HALF = WORLD_SIZE / 2;

export const HUNGER_MAX = 100;
export const HUNGER_DRAIN_PER_SECOND = 2;
export const SHOO_HUNGER_PENALTY = 5;

export const WALK_SPEED = 3;
export const SPRINT_SPEED = 5;
export const FLAP_IMPULSE = 5;
export const GRAVITY = 14;

export const STAMINA_MAX = 100;
export const FLAP_STAMINA_COST = 18;
export const STAMINA_RECOVERY_PER_SECOND = 28;

/** Levelling: XP is earned from eating, sprinting, and flying; each level
 *  raises the pigeon's stamina ceiling (so she can chain more flaps). */
export const XP_PER_FOOD_POINT = 2;
export const XP_PER_SPRINT_SECOND = 1;
export const XP_PER_FLY_SECOND = 2;
export const STAMINA_PER_LEVEL = 25;
/** Walk/sprint speed bonus added per level-up (m/s). */
export const SPEED_PER_LEVEL = 0.4;
/** Cumulative XP required to reach level N (index 0 → level 2). */
export const LEVEL_XP_REQUIREMENTS = [20, 60, 120, 200] as const;
export const MAX_LEVEL = LEVEL_XP_REQUIREMENTS.length + 1;

export const PECK_RANGE = 1.2;

export const PIGEON_HEIGHT = 0.32;
export const PIGEON_RADIUS = 0.18;

export const FOOD_TYPES = [
  { id: "breadcrumb", name: "Breadcrumb",  points: 1,  hungerGain: 6,  rarity: 0.45, color: 0xd6b36a },
  { id: "fry",        name: "French fry",  points: 3,  hungerGain: 10, rarity: 0.3,  color: 0xe8c547 },
  { id: "crust",      name: "Pizza crust", points: 8,  hungerGain: 20, rarity: 0.15, color: 0xb97a3d },
  { id: "donut",      name: "Donut",       points: 15, hungerGain: 30, rarity: 0.07, color: 0xf0aed4 },
  { id: "hotdog",     name: "Hot dog bun", points: 25, hungerGain: 40, rarity: 0.03, color: 0xc68b5b },
  // Special challenge reward item (not naturally spawned).
  { id: "popcorn",    name: "Movie popcorn", points: 50, hungerGain: 45, rarity: 0, color: 0xd93b2f },
] as const;

export type FoodTypeId = (typeof FOOD_TYPES)[number]["id"];
export type FoodType = (typeof FOOD_TYPES)[number];

export const SEED_REGEX = /^[a-z0-9]{8,32}$/;
export const LEADERBOARD_LIMIT = 10;
